import "@/assets/scss/mailer-cloud.scss";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import SidebarPlugin from "@/components/SidebarPlugin/index";
import VeeValidate from "vee-validate";
import vSelect from "@/components/VSelect";
import McFormInput from "@/components/McFormInput";
import ActionLayout from "@/layout/ActionLayout";
import McContainerLoader from "@/components/McContainerLoader";
import McFullPageLoader from "@/components/McFullPageLoader";
import VueSweetalert2 from "vue-sweetalert2";
import CustomSweetAlert from "@/plugins/sweetAlert";
import { errorTitle } from "@/common/constants";
import DOMPurify from "dompurify";

export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(SidebarPlugin);
    Vue.use(VeeValidate, {
      // This is the default
      inject: true,
      // Important to name this something other than 'fields'
      fieldsBagName: "veeFields",
      // errorBagName: 'veeErrors'
    });
    const dictionary = {
      en: {
        messages: {
          regex: () =>
            "Only alphanumeric characters, underscore,hyphen and space allowed, Start with letters only",
          min: (field, length) =>
            "The " +
            field +
            " should be atleast " +
            length +
            " characters long",
          max: (field, length) =>
            "The " +
            field +
            " cannot exceed more than " +
            length +
            " characters",
          required: (field) => "The " + field + " is required",
        },
      },
    };
    VeeValidate.Validator.localize(dictionary);
    VeeValidate.Validator.extend("no_script", {
      getMessage: () => `Script tags not allowed`,
      validate: (value) => {
        value = value.trim().toLowerCase();
        var re = /<script\b[^>]*>([\s\S]*?)/gm;
        var fr = /<iframe\b[^>]*>([\s\S]*?)/gm;
        if (re.test(value) || fr.test(value)) {
          value = "";
          return false;
        } else {
          return true;
        }
      },
    });
    VeeValidate.Validator.extend("no_html", {
      getMessage: () => `Tags not allowed`,
      validate: (value) => {
        value = value.trim();
        var div = document.createElement("div");
        div.innerHTML = DOMPurify.sanitize(value);
        var text = div.textContent || div.innerText || "";
        text = text.replace("<>", "");
        return (
          value === text && text.substring(text.length - 1, text.length) !== "<"
        );
      },
    });
    VeeValidate.Validator.extend("alpha_numeric", {
      getMessage: (field) => `Invalid ` + field,
      validate: (value) => {
        if (value) {
          var strongRegex = new RegExp(/^[a-zA-Z0-9-._ ]+$/i);
          return strongRegex.test(value);
        } else {
          return false;
        }
      },
    });

    VeeValidate.Validator.extend("alpha_then_numeric", {
      getMessage: (field) => `Invalid ` + field,
      validate: (value) => {
        if (value) {
          var strongRegex = new RegExp(/^[a-zA-Z][a-zA-Z0-9 ]+$/i);
          return strongRegex.test(value);
        } else {
          return false;
        }
      },
    });

    VeeValidate.Validator.extend("numeric_val", {
      getMessage: (field) => `Invalid ` + field,
      validate: (value) => {
        if (value) {
          var strongRegex = new RegExp(/^[0-9 ]+$/i);
          return strongRegex.test(value);
        } else {
          return false;
        }
      },
    });

    VeeValidate.Validator.extend("link_val", {
      getMessage: (field) => `The ` + field + ` field is not a valid URL`,
      validate: (value) => {
        if (value) {
          const urlPattern =
            /^(https?:\/\/)([\w.\u00C0-\u024F-]+)\.([a-z\u00C0-\u024F]{2,6}\.?)(\/[\w\u002D~.@#$%&*+?:,;_/=%\s]*)?$/i;
          return urlPattern.test(value.trim());
        } else {
          return false;
        }
      },
    });

    Vue.mixin({
      computed: {
        permission() {
          return Vue.ls.get("permission") === null
            ? 5
            : parseInt(Vue.ls.get("permission"));
        },
      },
      beforeRouteEnter(to, from, next) {
        next((vm) => {
          if (window.HubSpotConversations) {
            window.HubSpotConversations.widget.refresh();
            setTimeout(() => {
              window.HubSpotConversations.widget.close();
            }, 500);
          }
          vm.$bvModal.hide("modalChatboat");
          // vm.$intercom.hide()
          // var pages = ['Register', 'Login', 'RegisterAddress']
          // var currPage = to.name
          // if (pages.includes(currPage) || parseInt(vm.$ls.get('isAdmin')) === 1) {
          //   vm.$intercom.boot({ hide_default_launcher: true })
          // } else {
          //   vm.$intercom.boot({ hide_default_launcher: false })
          // }
        });
      },
      methods: {
        showError(error) {
          this.$showConfirm(errorTitle, error, "warning");
        },
        capitalize(str) {
          if (typeof str !== "string" || !str) {
            return "";
          }
          return str.charAt(0).toUpperCase() + str.slice(1);
        },
        focusElement(elId) {
          this.$nextTick(() => {
            if (document.getElementById(elId)) {
              document.getElementById(elId).focus();
            } else if (this.$refs[elId]) {
              this.$refs[elId].focus();
            }
          });
        },
      },
    });

    Vue.component("v-select", vSelect);
    Vue.component("mc-form-input", McFormInput);
    Vue.component("action-layout", ActionLayout);
    Vue.component("container-loader", McContainerLoader);
    Vue.component("fullpage-loader", McFullPageLoader);
    Vue.use(VueSweetalert2, { includeCss: false });
    Vue.use(CustomSweetAlert);
    Vue.directive("focus", {
      inserted: function (el) {
        if (
          el.nodeName !== "INPUT" &&
          el.getElementsByTagName("input").length
        ) {
          el = el.getElementsByTagName("input")[0];
        }
        el.focus();
      },
    });
  },
};
